module.exports = __webpack_public_path__ + "static/media/handStrength2.9f0ed753.png";